import { IntegrationSystem } from '@/shared/types';

import { SERVICE_CODES } from '@/lib/consts';

import { FormDocument } from '@/api/types';

import { AccordionData } from '../../../../../../../components/Accordion/Accordion';
import { AddressBlockPreview } from '../../../../../../../components/Forms/AddressBlock';
import { DocumentsDataPreview } from '../../../../../../../components/Forms/DocumentsData';
import { PlaceOfResidenceFormDataProps } from '../../../../../../../components/Forms/Steps/PlaceOfResidence';
import { StepsNavigationName } from '../../../../../../../config/services';
import { currentServiceCode } from '../../TemporaryResidenceRelocation';

import { DeclaredAddressNewFieldName } from './types';

interface Props {
  formData: {
    [DeclaredAddressNewFieldName.declaredAddressNew]?: string;
    [DeclaredAddressNewFieldName.issuedResidence]?: string;
    [DeclaredAddressNewFieldName.expiredResidence]?: string;
    [DeclaredAddressNewFieldName.declaredAddressNewDocuments]?: Array<FormDocument<IntegrationSystem.ERZ>>;
  } & PlaceOfResidenceFormDataProps;
}

export const previewStep5 = ({ formData }: Props): AccordionData => {
  return currentServiceCode === SERVICE_CODES.RESIDENCE_RELOCATION
    ? {
        title: StepsNavigationName.newAddressOfResidence,
        content: (
          <>
            <div className="custom-columns__content-title">{StepsNavigationName.newAddressOfResidence}</div>
            <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
              <AddressBlockPreview
                stringifiedAddress={formData[DeclaredAddressNewFieldName.declaredAddressNew] as string}
              />
            </div>
            <div className="custom-columns__content-title">
              Документ, що підтверджує нову адресу місця проживання (зберігання зброї)
            </div>
            <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
              <DocumentsDataPreview
                documents={formData[DeclaredAddressNewFieldName.declaredAddressNewDocuments] ?? []}
                documentTypeLabel="Тип документа, що підтверджує нову адресу місця проживання (зберігання зброї)"
                documentUploadLabel="Документ, що підтверджує нову адресу місця проживання (зберігання зброї)"
              />
            </div>
          </>
        ),
      }
    : {
        title: StepsNavigationName.newTemporaryAddressOfResidence,
        content: (
          <>
            <div className="custom-columns__content-title">{StepsNavigationName.newTemporaryAddressOfResidence}</div>
            <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
              <AddressBlockPreview
                stringifiedAddress={formData[DeclaredAddressNewFieldName.declaredAddressNew] as string}
              />
            </div>
            <div className="custom-columns__content-title">
              Дані документа, який підтверджує адресу тимчасового місця зберігання зброї
            </div>
            <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
              <DocumentsDataPreview
                documents={formData[DeclaredAddressNewFieldName.declaredAddressNewDocuments] ?? []}
                documentTypeLabel="Тип документа, що підтверджує адресу тимчасового місця зберігання зброї"
                documentUploadLabel="Документ, що підтверджує адресу тимчасового місця зберігання зброї"
              />
            </div>
          </>
        ),
      };
};
